"use strict";

var _classCallCheck = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var web3_interface_adapter_1 = require("./web3-interface-adapter");

var supportedEvmNetworks = ["ethereum", "fabric-evm", "quorum"];

var getNetworkTypeClass = function getNetworkTypeClass(_ref) {
  var _ref$networkType = _ref.networkType,
      networkType = _ref$networkType === void 0 ? "ethereum" : _ref$networkType;
  if (supportedEvmNetworks.includes(networkType)) return "evm-like";
  return networkType;
};

var InterfaceAdapter =
/*#__PURE__*/
function () {
  function InterfaceAdapter(options) {
    _classCallCheck(this, InterfaceAdapter);

    switch (getNetworkTypeClass(options)) {
      case "evm-like":
        this.adapter = new web3_interface_adapter_1.Web3InterfaceAdapter({
          provider: options.provider,
          networkType: options.networkType
        });
        break;

      default:
        throw Error("Sorry, \"".concat(options.networkType, "\" is not supported at this time."));
    }

    return this.adapter;
  }

  _createClass(InterfaceAdapter, [{
    key: "getNetworkId",
    value: function getNetworkId() {
      return this.adapter.getNetworkId();
    }
  }]);

  return InterfaceAdapter;
}();

exports.InterfaceAdapter = InterfaceAdapter;